import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { Button } from '../ui/Button';
import { useCountdown } from '../hooks/useCountdown';
export function ClosingSection() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const scrollToPricing = () => {
    document.getElementById('checkout-btn')?.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  };
  const options = [{
    title: 'Pack Base',
    desc: 'Pack + 2 bonos',
    oldPrice: '$49.975 ARS',
    price: '$19.990 ARS',
    isElite: false
  }, {
    title: 'Pack + Atlas',
    desc: 'Pack + 2 bonos + Atlas',
    oldPrice: '$64.975 ARS',
    price: '$25.990 ARS',
    isElite: false
  }, {
    title: 'Pack + Protocolos',
    desc: 'Pack + 2 bonos + Protocolos',
    oldPrice: '$64.975 ARS',
    price: '$25.990 ARS',
    isElite: false
  }, {
    title: 'Pack Élite',
    desc: 'Pack + 2 bonos + Atlas + Protocolos',
    oldPrice: '$72.475 ARS',
    price: '$28.990 ARS',
    isElite: true
  }];
  return <section className="py-12 bg-background-dark relative overflow-hidden" data-id="element-62">
      <div className="container mx-auto px-4 max-w-6xl relative z-10" data-id="element-63">
        <FadeIn className="text-center mb-10" data-id="element-64">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-white font-heading mb-2" data-id="element-65">
            La próxima clase podés seguir improvisando.
          </h2>
          <h3 className="text-4xl md:text-5xl lg:text-6xl font-black text-primary font-heading mb-6" data-id="element-66">
            O podés tener todo el respaldo técnico desde hoy.
          </h3>
          <p className="text-xl text-gray-400 italic max-w-3xl mx-auto" data-id="element-67">
            Este material fue creado para vos, donde sea que trabajés.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} className="text-center mb-10" data-id="element-68">
          <h4 className="text-lg font-bold text-white mb-4" data-id="element-69">
            ⏰ El precio promocional cierra en:
          </h4>
          <div className="flex justify-center items-center gap-4 mb-4" data-id="element-70">
            <div className="flex flex-col items-center" data-id="element-71">
              <div className="text-4xl md:text-6xl font-black text-urgency font-heading tabular-nums animate-pulse" style={{
              animationDuration: '2s'
            }} data-id="element-72">
                {hours}
              </div>
              <span className="text-xs text-white font-medium mt-1 notranslate" translate="no" data-id="element-73">
                HS
              </span>
            </div>
            <div className="text-3xl md:text-5xl font-black text-urgency/50 pb-4" data-id="element-74">
              :
            </div>
            <div className="flex flex-col items-center" data-id="element-75">
              <div className="text-4xl md:text-6xl font-black text-urgency font-heading tabular-nums animate-pulse" style={{
              animationDuration: '2s'
            }} data-id="element-76">
                {minutes}
              </div>
              <span className="text-xs text-white font-medium mt-1 notranslate" translate="no" data-id="element-77">
                MIN
              </span>
            </div>
            <div className="text-3xl md:text-5xl font-black text-urgency/50 pb-4" data-id="element-78">
              :
            </div>
            <div className="flex flex-col items-center" data-id="element-79">
              <div className="text-4xl md:text-6xl font-black text-urgency font-heading tabular-nums animate-pulse" style={{
              animationDuration: '2s'
            }} data-id="element-80">
                {seconds}
              </div>
              <span className="text-xs text-white font-medium mt-1 notranslate" translate="no" data-id="element-81">
                SEG
              </span>
            </div>
          </div>
          <p className="text-white font-bold" data-id="element-82">
            Después sube el precio y no vuelve a bajar.
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-10" data-id="element-83">
          {options.map((opt, index) => <FadeIn key={index} delay={0.3 + 0.1 * index} direction="up" data-id="element-84">
              <div className={`
                bg-card-dark rounded-2xl p-6 h-full flex flex-col items-center text-center relative
                ${opt.isElite ? 'border-2 border-primary shadow-[0_0_20px_rgba(255,107,0,0.15)]' : 'border border-card-border-dark'}
              `} data-id="element-85">
                {opt.isElite && <div className="absolute -top-3 bg-primary text-black text-xs font-bold uppercase tracking-wider py-1 px-3 rounded-full shadow-lg" data-id="element-86">
                    🏆 MÁS ELEGIDO
                  </div>}

                <h4 className="text-xl font-bold text-white mb-2 mt-2" data-id="element-87">
                  {opt.title}
                </h4>
                <p className="text-sm text-gray-400 mb-4 flex-1" data-id="element-88">{opt.desc}</p>
                <p className="text-gray-500 line-through text-sm mb-1 notranslate" translate="no" data-id="element-89">
                  {opt.oldPrice}
                </p>
                <div className="text-2xl font-black text-primary font-heading mb-6 notranslate" translate="no" data-id="element-90">
                  {opt.price}
                </div>

                <Button fullWidth onClick={scrollToPricing} className="py-3 px-4 text-sm md:text-base w-full" data-id="element-91">
                  → ELEGIR ESTA OPCIÓN
                </Button>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.8} className="text-center" data-id="element-92">
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-gray-400 mb-4" data-id="element-93">
            <span data-id="element-94">🔒 Pago 100% seguro</span>
            <span className="hidden md:inline" data-id="element-95">—</span>
            <span data-id="element-96">⚡ Acceso en 5 minutos</span>
            <span className="hidden md:inline" data-id="element-97">—</span>
            <span data-id="element-98">🛡️ Garantía 7 días sin preguntas</span>
          </div>
          <div className="flex items-center justify-center gap-2 text-sm text-gray-400" data-id="element-99">
            <span data-id="element-100">💻 Mercado Pago</span>
          </div>
        </FadeIn>
      </div>
    </section>;
}